import { render, staticRenderFns } from "./GlobalLoad.vue?vue&type=template&id=25340b28&scoped=true"
import script from "./GlobalLoad.vue?vue&type=script&lang=js"
export * from "./GlobalLoad.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoad.vue?vue&type=style&index=0&id=25340b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25340b28",
  null
  
)

export default component.exports